import { supabase } from './client';

export interface ShipmentPlan {
  id: string;
  report_name: string;
  report_date: string;
  file_id: string;
  full_url: string;
  file_name: string;
  summary: string | null;
  auth_user_id: string;
  user_id: string | null;
  created_by_user_id: string | null;
  created_at: string;
  updated_at: string;
}

export interface ListShipmentPlansParams {
  search?: string;
  limit?: number;
  offset?: number;
}

export async function listShipmentPlans({
  search,
  limit = 50,
  offset = 0,
}: ListShipmentPlansParams = {}): Promise<{ data: ShipmentPlan[]; count: number }> {
  let query = supabase
    .from('shipment_plans')
    .select('*', { count: 'exact' })
    .order('report_date', { ascending: false })
    .order('created_at', { ascending: false })
    .range(offset, offset + limit - 1);

  if (search && search.trim()) {
    query = query.ilike('report_name', `%${search.trim()}%`);
  }

  const { data, count, error } = await query;
  if (error) throw new Error(error.message);
  return { data: (data || []) as ShipmentPlan[], count: count ?? 0 };
}

export async function deleteShipmentPlan(id: string): Promise<void> {
  const { error } = await supabase.from('shipment_plans').delete().eq('id', id);
  if (error) throw new Error(error.message);
}

export interface UpdateShipmentPlanMetaInput {
  report_name?: string;
  report_date?: string;
  summary?: string | null;
}

export async function updateShipmentPlanMeta(
  id: string,
  input: UpdateShipmentPlanMetaInput
): Promise<void> {
  const { error } = await supabase.from('shipment_plans').update(input).eq('id', id);
  if (error) throw new Error(error.message);
}
